/**
 * Diccionario en español. Es la referencia: `en.ts` se tipa contra él, de modo
 * que olvidar una clave es un error de compilación y no un hueco en pantalla.
 */
export const es = {
  appName: 'Miyuki',

  // Diseño nuevo
  newDesign: 'Nuevo diseño',
  columns: 'Columnas',
  colors: 'Colores',
  create: 'Crear',
  untitledDesign: 'Sin título',
  columnsOutOfRange: 'El ancho debe estar entre 1 y 30 columnas',
  colorsOutOfRange: 'Los colores deben estar entre 1 y 99',

  // Lienzo
  canvasLabel: 'Lienzo del diseño',
  canvasDescription: 'Cuadrícula de la pulsera. Toca una celda para colocar una mostacilla.',
  rowNumber: 'Fila {n}',

  // Paleta
  palette: 'Paleta',
  eraser: 'Borrador',
  editColor: 'Editar color',
  addColor: 'Agregar color',
  colorLimitReached: 'Declaraste {n} colores y ya están todos en uso.',
  raiseColorLimit: '¿Ampliar a {n}?',
  maxColorsReached: 'Un diseño no puede superar los 99 colores.',
  removeColor: 'Quitar color',
  reassignBeadsTitle: '¿A qué color pasan las mostacillas?',
  reassignBeadsBody: '{n} mostacillas usan este color.',
  leaveEmpty: 'Dejar vacías',

  // Filas
  addRow: 'Agregar fila',
  insertRowAbove: 'Insertar fila encima',
  duplicateRow: 'Duplicar fila',
  removeRow: 'Eliminar fila',
  maxRowsReached: 'El diseño no puede superar las 500 filas.',
  rowActions: 'Acciones de la fila {n}',

  // Ancho
  resizeColumns: 'Cambiar el ancho',
  beadsWillBeLost: 'Se perderán {n} mostacillas.',

  // Historial
  undo: 'Deshacer',
  redo: 'Rehacer',

  // Guardado
  save: 'Guardar',
  saveAs: 'Guardar como',
  designName: 'Nombre del diseño',
  myDesigns: 'Mis diseños',
  open: 'Abrir',
  rename: 'Renombrar',
  duplicate: 'Duplicar',
  delete: 'Eliminar',
  noDesignsYet: 'Todavía no guardaste ningún diseño.',
  designMeta: '{columns} col · {rows} filas · {date}',

  nameTakenTitle: 'Ese nombre ya existe',
  nameTakenBody: 'Ya hay un diseño llamado «{name}». ¿Reemplazarlo?',
  replace: 'Reemplazar',

  confirmDeleteTitle: '¿Eliminar el diseño?',
  confirmDeleteBody: '«{name}» se borrará de este dispositivo y no se podrá recuperar.',

  unsavedChangesTitle: 'Tienes cambios sin guardar',
  unsavedChangesBody: 'Si continúas, perderás lo que hiciste desde el último guardado.',
  discardChanges: 'Descartar cambios',

  resumeDraftTitle: 'Tienes un diseño sin guardar',
  resumeDraftBody: 'Dejaste un diseño a medias la última vez. ¿Quieres retomarlo?',
  resume: 'Retomar',
  discard: 'Descartar',

  saveFailedQuota: 'No hay espacio en el navegador para guardar este diseño.',
  saveFailedUnavailable: 'Este navegador no permite guardar diseños.',
  loadFailedCorrupt: 'Este diseño está dañado y no se puede abrir.',

  // Ajustes del diseño
  settings: 'Ajustes del diseño',
  apply: 'Aplicar',
  resizeColumnsTitle: '¿Cambiar el ancho?',

  // Encuadre
  fitToScreen: 'Ver todo',
  moreRowsAbove: 'Hay más filas más arriba',
  moreRowsBelow: 'Hay más filas más abajo',

  // Tipo de patrón
  patternType: 'Tipo de patrón',
  patternTypeLoom: 'Cuadrícula recta',
  patternTypePeyote: 'Escalonado',
  patternTypeLoomHint: 'Cada mostacilla va justo encima de la de abajo (loom).',
  patternTypePeyoteHint: 'Cada fila va corrida media mostacilla (peyote).',

  // Menú y guía
  menu: 'Menú',
  quickGuide: 'Guía rápida',
  guidePanTitle: 'Mover el diseño',
  guidePanBody: 'Arrastra con dos dedos. Con un dedo se pinta, así que el lienzo no se mueve.',
  guideZoomTitle: 'Acercar y alejar',
  guideZoomBody:
    'Pellizca con dos dedos. El botón «Ver todo» devuelve el diseño completo a la pantalla.',
  guideSaveTitle: 'Guardar',
  guideSaveBody:
    'El punto junto al nombre avisa de cambios sin guardar. «Guardar», en este menú, los guarda con un nombre.',
  guideNewDesignTitle: 'Empezar un diseño',
  guideNewDesignBody: '«Nuevo diseño» pide el ancho, cuántos colores tendrá y el tipo de patrón.',
  guidePaletteTitle: 'Colores',
  guidePaletteBody:
    'Toca un color para activarlo y vuelve a tocarlo para cambiarlo o quitarlo. El botón «+» agrega uno más.',
  guideRowsTitle: 'Filas',
  guideRowsBody:
    '«Agregar fila» añade una al final. Tocar el número de una fila ofrece insertar encima, duplicar o eliminar.',
  guidePatternTypesTitle: 'Tipos de patrón',
  guidePatternTypesBody:
    'En la cuadrícula recta cada mostacilla va encima de la de abajo. En el escalonado, cada fila va corrida media mostacilla, como los ladrillos de una pared.',

  // Modo seguimiento
  trackingStart: 'Seguir el tejido',
  trackingExit: 'Volver al diseño',
  trackingPosition: 'Fila {n} de {total}',
  trackingPercent: '{n}\u00a0%',
  trackingRowsRemaining: 'Faltan {n} filas',
  trackingRowsRemainingOne: 'Falta 1 fila',
  trackingBeadsRemaining: 'Quedan {n} mostacillas por ensartar',
  trackingCompleteRow: 'Fila lista',
  trackingUndo: 'Deshacer avance',
  trackingRedo: 'Rehacer avance',
  trackingGoToRow: 'Ir a una fila',
  trackingGoToRowLabel: 'Número de fila',
  trackingGoToRowInvalid: 'El diseño tiene {total} filas',
  trackingReset: 'Empezar de nuevo',
  trackingResetTitle: '¿Empezar de nuevo?',
  trackingResetBody: 'El avance vuelve a la fila 1. El diseño no cambia.',
  trackingFinished: 'Pulsera terminada',
  trackingFinishedBody: 'Están tejidas las {total} filas.',
  trackingSummary: 'Mostacillas de la fila {n}',
  trackingGap: 'Hueco',
  trackingGapCount: '{n} sin mostacilla',
  trackingColorOrdinal: 'Color {n}',
  trackingRunCount: '{n} × color {color}',
  trackingFromRight: 'Se ensarta de derecha a izquierda',
  trackingFromLeft: 'Se ensarta de izquierda a derecha',
  trackingAlternates: 'Alternar el sentido fila a fila',
  trackingAlternatesHint: 'Al terminar una fila el hilo queda del otro lado.',

  // Comunes
  cancel: 'Cancelar',
  confirm: 'Confirmar',
  close: 'Cerrar',
} as const;

export type MessageKey = keyof typeof es;

/**
 * Las claves son las del español, pero los valores son `string` y no el
 * literal en español: si no, `en.ts` tendría que repetir las cadenas
 * castellanas para compilar.
 */
export type Messages = Record<MessageKey, string>;
